
import {
  defineComponent,
  computed,
  onBeforeMount,
  ComputedRef
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Card from "./Card.vue";
import { Interest } from "../../../../../domain/entities/entities";
import { dispatchError } from "../../../utils/error_handling";
import { wrapLoading } from "../../../utils/wrap_loading";

export default defineComponent({
  name: "InterestSection",
  components: {
    Card,
    Carousel,
    Navigation,
    Slide
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    function formattedImageURL(imageURL: string): string {
      return `url(${imageURL})`;
    }

    async function loadUserInterests(): Promise<void> {
      try {
        await wrapLoading(async () => {
          await store.dispatch("interest_module/getUserInterests");
        });
      } catch (e) {
        await dispatchError(e);
      }
    }

    onBeforeMount(loadUserInterests);

    const interestsTrainings: ComputedRef<Interest[]> = computed(
      () => store.getters["interest_module/userInterests"] || []
    );

    function goToInterest(interest: Interest) {
      router.push({
        name: "interest",
        params: { interest_id: interest.id },
        query: { title: interest.title }
      });
    }

    const recommendedSettings = {
      itemsToShow: 5,
      itemsToScroll: 5,
      snapAlign: "start",
      transition: 800,
      wrapAround: false
    };

    const recommendedBreakpoints = {
      320: { itemsToShow: 5, itemsToScroll: 5 },
    };

    return {
      interestsTrainings,
      recommendedSettings,
      recommendedBreakpoints,
      formattedImageURL,
      goToInterest
    };
  }
});
